<template>
  <div class="home">
    <!--轮播图-->
    <div class="banner">
      <div class="van-search">
        <!-- <div class='nav-back'>
          <b class='nav-back-icon'></b>
        </div> -->
        <div class="van-search__input-wrap">
          <i class="search-icon"></i>
          <input type="search"
                 @focus="toSearch"
                 placeholder="请输入搜索关键词"
                 class="van-search__input">
          <i class="van-icon van-icon-clear"
             style="display: none;"></i>
        </div>
      </div>
      <van-swipe :autoplay="3000"
                 height='auto'
                 indicator-color='#333'>
        <van-swipe-item v-for="(myimage, index) in myimages"
                        :key="index">
          <img v-lazy="myimage"
               class='bannerImg' />
          <!-- <div class='bannerImg'></div> -->
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--商品选项 所有选择-->
    <div class='
               product-nav'>
      <ol class='clearfix'>
        <li @click="searchList(-1)">所有</li>
        <li @click='searchList(0)'>烟雾器</li>
        <li @click='searchList(4)'>温控器</li>
        <li @click='searchList(2)'>温湿器</li>
        <li @click='searchList(3)'>卡片机</li>
        <li @click='searchList(5)'
            v-if='isDown ==1'>猫眼</li>
        <li @click='searchList(1)'
            v-if='isDown ==1'>报警器</li>
      </ol>
      <i class='down'
         v-if='isDown==0'
         @click="showDown"></i>
      <i class='up'
         v-else
         @click="showUp"></i>
    </div>
    <!-- 瀑布流加载数据
延缓加载数据方法的引用
  v-waterfall-lower="loadMore"
 -->
    <!--商品列表-->
    <div class="
             goods-list-wrapper">
      <ul class="goods-list"
          waterfall-disabled="isWaterfallDisabled"
          waterfall-offset="400">
        <li v-for="(list,index) in lists"
            :key="index"
            @click='getProductID(index)'>
          <!--<router-link  :to="{name: 'detail', params: {id: list.id}}">-->
          <!--<router-link :to="{path:'/detail',query: {name: id}}">-->
          <router-link :to="{name:'detail',params:{id:list.id}}">
            <div class="photo">
              <!-- <img v-lazy="list.img">  -->
              <img :src="list.src"
                   alt="">
            </div>
            <div class="info">
              <div class="title">
                {{list.name}}
              </div>
              <div class='label'>
                {{list.name}}
              </div>
              <div class="bot">
                <span class="price">￥{{list.price}}</span>
                <div class="btn-buy"></div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <!-- <div class="loading"
           v-if="loading">
        <van-loading :type="'spinner'"
                     :color="'black'"></van-loading><span>加载中...</span>
      </div> -->
      <!-- 暂时隐藏 -->

    </div>
    <!--<div class="load" v-show="loading"><van-loading type="spinner" color="black" />加载中...</div>-->

    <!-- 购物车 个用户 -->
    <div class='card-person'>
      <div class='nav-card'>
        <i @click='toCart'></i>
      </div>
      <div class='nav-person'>
        <i @click='toMine'></i>
      </div>
    </div>
    <div class='no-product'>
      <div class='productHr'>
        <hr />
      </div>
      <div><span>没有更多商品了</span></div>
      <div class='productHr'>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import url from '../../assets/js/api.js'
import axios from 'axios'

import { Card, Loading } from 'vant';
Vue.component(Card.name, Card);
//Vue.component(Loading.name, Loading);

import { Waterfall } from 'vant';
import { debug } from 'util';

export default {
  data () {
    return {
      //图片懒加载
      myimages: [
        '../../../static/image/thermostat/img.png',
        '../../../static/image/alarmDevice/banner4.jpg'
        // '../../../static/image/温控器白/img.png',
        // '../../../static/image/智能猫眼/img1.png'
      ],
      lists: null,
      bannerLists: null,
      isWaterfallDisabled: false,
      loading: false,
      nodata: 1,
      pageNum: 1,
      pageSize: 6,
      isDown: 0,
    }
  },
  mounted () {
    // //debugger
    // this.getBanner() --》首页数据获取

    console.log('this.$store.state.lists:');
    console.log(this.$store.state.lists);
    this.getHomeData();
  },
  directives: {
    WaterfallLower: Waterfall('lower')
  },
  methods: {
    //导航搜索
    searchList (index) {
      //debugger
      if (index == -1) {
        this.getHomeData();
      } else {
        this.lists = [];
        this.lists.push(this.$store.state.lists[index]);
      }
    },
    //收缩
    showDown () {
      this.isDown = 1;
    },

    showUp () {
      this.isDown = 0;
    },
    //展开

    //点击获取商品的ID，修改store上的product_id上，详情页再取此ID
    getProductID (pro_id) {
      ////debugger
      this.$store.commit('change_pro_id', pro_id);
    },
    //获取首页数据，用store的固定数据
    getHomeData () {
      this.lists = this.$store.state.lists;
    },
    //首页图片请求
    getBanner () {
      axios.get(url.banner).then(res => {
        this.images = res.data.lists
      })
    },
    toCart () {
      this.$router.push({ name: 'cart' });
    },
    toMine () {
      this.$router.push({ name: 'my' });
    },
    //跳转到搜索首页
    toSearch () {
      this.$router.push('/home_search');
    }
  }
}
</script>

<style lang="less" scoped="">
.van-toast-wrapper {
  display: none !important;
}
.home {
  background-color: #f7f7f7;
  // padding-bottom: 0.88rem;

  .van-swipe {
    height: 5.3rem;
    img {
      max-width: 100%;
      height: auto;
    }
    .bannerImg {
      display: inline-block;
      max-width: 100%;
      height: auto;
    }
  }
  .van-search {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    padding: 0.12rem 0.2rem;

    .nav-back {
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.2rem;
      box-sizing: border-box;

      .nav-back-icon {
        display: block;
        width: 100%;
        height: 100%;
        background: url("../../../static/image/icon/ios/back.png") no-repeat
          center center;
      }
    }
    .van-search__input-wrap {
      border-radius: 30px;
      width: 4.8rem;

      .search-icon {
        display: inline-block;
        position: absolute;
        left: 10px;
        width: 16px;
        height: 16px;
        background: url("../../../static/image/icon/ios/Search.png") no-repeat
          center center;
      }
    }
  }
  .product-nav {
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 0.2rem 0.3rem;

    ol {
      list-style: none;

      li {
        float: left;
        margin-right: 0.5rem;
        margin-bottom: 0.2rem;
        font-size: 0.28rem;
        text-decoration: none;
        color: rgb(102, 102, 102);
      }
    }
    & > .down {
      position: absolute;
      top: 0.2rem;
      right: 0.3rem;
      display: block;
      width: 0.38rem;
      height: 0.38rem;
      color: #333;
      font-size: 20px;
      background: url("../../../static/image/icon/ios/drop_down.png") no-repeat
        center center;
    }
    & > .up {
      position: absolute;
      top: 0.2rem;
      right: 0.3rem;
      display: block;
      width: 0.38rem;
      height: 0.38rem;
      color: #333;
      font-size: 20px;
      background: url("../../../static/image/icon/ios/drop_up.png") no-repeat
        center center;
    }
  }
  //瀑布效果
  .goods-list-wrapper {
    padding: 0 0.3rem;
    .goods-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        // float: left;
        height: auto;
        border-radius: 10px;
        overflow: hidden;
        width: 3.38rem;
        background: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 10%);
        margin-bottom: 0.16rem;

        &:nth-child(1) {
          .info {
            margin-top: 0.5rem;
            padding: 0 0.24rem 0.32rem;
          }
        }
        .photo {
          height: 3.22rem;
          background: #e5e5e5;
          img {
            height: 100%;
          }
        }

        .info {
          margin-top: 0.32rem;
          padding: 0 0.24rem 0.32rem;
          .title {
            font-size: 0.28rem;
            color: #000;
            line-height: 0.38rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .label {
            margin-top: 0.16rem;
            font-size: 0.22rem;
            color: rgb(138, 138, 147);
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bot {
            margin-top: 0.24rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0.1rem 0 0 0;
            .price {
              font-size: 0.28rem;
              color: rgb(255, 144, 0);
            }
            .btn-buy {
              border-radius: 50%;
              width: 0.44rem;
              height: 0.44rem;
              background: url("../../../static/image/icon/ios/Join_buy.png")
                no-repeat center center;
            }
          }
        }
      }
    }
  }
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.clearfix {
  zoom: 1;
}
.first-water {
  margin-bottom: 0.5rem !important;
}

//没有更多的请求了（暂时隐藏）
.no-product {
  position: relative;

  div {
    float: left;
    width: 35%;
    height: 1rem;
    line-height: 1rem;
    box-sizing: border-box;
    padding-top: 0.4rem;

    .productHr {
      box-sizing: border-box;
      padding-top: 0.4rem !important;
    }

    &:nth-child(2) {
      height: 1rem;
      line-height: 1rem;
      position: relative;
      width: 30%;
      text-align: center;
      vertical-align: middle;

      span {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        display: inline-block;
        text-align: center;
      }
    }
    span {
      font-size: 0.2rem;
      color: rgb(197, 197, 197);
    }
    hr {
      font-size: 0.2rem;
      color: #c5c5c5;
    }
  }
}

//固定
.card-person {
  position: fixed;
  bottom: 0.88rem;
  right: 0.3rem;

  div {
    overflow: hidden;
    border-radius: 50%;
    //background-color: #9e9e9e;
    i {
      display: block;
      width: 0.64rem;
      height: 0.64rem;
    }

    &:nth-child(1) {
      margin-bottom: 0.12rem;
      i {
        background: url("../../../static/image/icon/ios/cart.png") no-repeat
          center center;
      }
    }
    &:nth-child(2) {
      i {
        background: url("../../../static/image/icon/ios/mine.png") no-repeat
          center center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue